/* ==========================================================================
   Multicolumn: Reveal — small companion script.

   The reveal itself is a native <details>/<summary>, so open/close, icon swap,
   scrim change and keyboard all work with zero JS. This script only adds:
     1. a fade-out on close (native <details> hides instantly otherwise),
     2. accordion mode (opening one card closes the others),
     3. an `.is-open` class on the card as a :has() fallback,
     4. theme-editor hooks (block select opens that card).
   ========================================================================== */

(function () {
  if (window.__mcrInit) return;
  window.__mcrInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSection(section) {
    if (!section || section.__mcrReady) return;
    section.__mcrReady = true;
    if (/(^|; )inspd_s=[02]/.test(document.cookie) && !(window.Shopify && Shopify.designMode)) {
      section.style.display = 'none';
      return;
    }

    var accordion = section.getAttribute('data-accordion') === 'true';
    var disclosures = Array.prototype.slice.call(
      section.querySelectorAll('.multicolumn-reveal__disclosure')
    );

    disclosures.forEach(function (d) {
      var summary = d.querySelector('.multicolumn-reveal__toggle');
      var text = d.querySelector('.multicolumn-reveal__text');
      d.__card = d.closest('.multicolumn-reveal__card');

      // Reflect open state on the card (fallback for :has()), and run accordion.
      d.addEventListener('toggle', function () {
        if (d.__card) d.__card.classList.toggle('is-open', d.open);
        if (d.open && accordion) {
          disclosures.forEach(function (other) {
            if (other !== d && other.open) other.open = false;
          });
        }
      });

      // Fade out before closing (opening is left to the native/CSS animation).
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (!d.open) return;           // about to open → native handles it
          if (reduce.matches) return;    // no motion → native instant close
          if (d.classList.contains('is-closing')) return;
          e.preventDefault();
          d.classList.add('is-closing');
          var done = function () {
            if (text) text.removeEventListener('animationend', done);
            d.classList.remove('is-closing');
            d.open = false;
          };
          if (text) {
            text.addEventListener('animationend', done);
          } else {
            done();
          }
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.multicolumn-reveal').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init fresh nodes; open the card being edited.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.multicolumn-reveal');
      if (s) initSection(s);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var d = e.target.querySelector('.multicolumn-reveal__disclosure');
      if (d && !d.open) d.open = true;
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var d = e.target.querySelector('.multicolumn-reveal__disclosure');
      if (d && d.open) {
        d.classList.remove('is-closing');
        d.open = false;
      }
    });
  }
})();
